import { render, staticRenderFns } from "./recon-details.vue?vue&type=template&id=d961767c&scoped=true&"
import script from "./recon-details.vue?vue&type=script&lang=js&"
export * from "./recon-details.vue?vue&type=script&lang=js&"
import style0 from "./recon-details.vue?vue&type=style&index=0&id=d961767c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d961767c",
  null
  
)

export default component.exports